import type { Theme, WithStyles } from '@material-ui/core'
import { createStyles, withStyles } from '@material-ui/core'
import { Typography } from '@paintscout/ui'
import React from 'react'

export const styles = (theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: `0 ${theme.spacing(0.5)}px`,
      [theme.breakpoints.down('sm')]: {
        margin: `0 ${theme.spacing(0.25)}px`
      }
    },
    operator: {
      ...theme.typography.button,
      paddingTop: theme.spacing(0.25),
      paddingLeft: 3,
      textTransform: 'none',
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(10),
        paddingTop: theme.spacing(0.33),
        paddingLeft: 1
      }
    }
  })
}

export interface CalculationOperatorProps extends WithStyles<typeof styles> {
  label?: string
}

function CalculationOperator(props: CalculationOperatorProps) {
  const { label, classes } = props
  return (
    <div className={classes.root}>
      <Typography variant={'overline'} classes={{ root: classes.operator }}>
        {label}
      </Typography>
    </div>
  )
}

export default withStyles(styles)(CalculationOperator)
